import React from "react";
import HeadComponent from "@js/components/Head";
import { ChallengesPageProps } from "@js/components/Education/types";
import ChallengesUnderConstruction from "@js/components/Challenges/ChallengesUnderConstruction";

const props: ChallengesPageProps = {
    challenges: [],
};

const defaultProps: any = {
    props: props,
};

// export async function getServerSideProps(context: any) {
// try {
//     const response = await fetch(
//         `${process.env.NEXT_HOST}/api/getChallengeQuestions`,
//         {
//             method: "GET",
//             headers: {
//                 "Content-Type": "application/json",
//             },
//         }
//     );
//     const tar: TrialityApiResponse = await response.json();
//     const challenges = tar.data;
//     if (!challenges) return defaultProps;
//     return {
//         props: {
//             challenges: challenges,
//         },
//     };
// } catch (e) {
//     console.error(e);
//     return defaultProps;
// }
// }

const ChallengesPage = (props: ChallengesPageProps) => {
    return (
        <>
            <HeadComponent title={"Challenges"} />
            <ChallengesUnderConstruction />
        </>
    );
};

export default ChallengesPage;
